module.exports = __webpack_public_path__ + "img/contributionOrange.6c291e3e.png";